export default (product, productVariant, sku) => {
    return (product && product.onSale) || (productVariant && productVariant.onSale) || (sku && sku.onSale);
};
